import { SpeedDialAction, Tabs, TagBox, Toolbar } from "devextreme-react";
import { useEffect, useState } from "react";
import SalesGrid from "./SalesGrid";
import axios from "axios";
import { Item } from "devextreme-react/toolbar";
import { useDispatch } from "react-redux";
import { updateDuration } from "../Redux/sales";
import ScrollToTopButtonComponent from "./ScrollToTopButtonComponent";
import DataSource from "devextreme/data/data_source";
import QuotationListComponent from "./QuotationListComponent";
import CustomStore from "devextreme/data/custom_store";

export default function SalesContract(props) {
  const { sales } = props;

  const dispatch = useDispatch();

  const [contrCat, setContrCat] = useState("ALL");
  const [dataSource, setDataSource] = useState([
    {
      text: "ALL",
      type: "ALL",
    },
    {
      text: "PF",
      type: "PF",
    },
    {
      text: "AOS",
      type: "AOS",
    },
  ]);
  const [quotListValue, setQuotListValue] = useState(null);
  const [quotDataSource, setQuotDataSource] = useState(null);
  const [quot, setQuot] = useState([]);
  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/sales/quot/${sales.contrNo}`
    );

    setQuot(result.data);

    setQuotDataSource(
      new CustomStore({
        loadMode: "raw",
        key: "quotNo",
        load() {
          return result.data;
        },
      })
    );
  }, [sales.contrNo]);

  // useEffect(() => {

  // }, [quotListValue]);

  const itemRender = (e) => {
    return (
      <div
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          color: "black",
          textTransform: "none",
        }}
      >
        {e.text}
      </div>
    );
  };

  const onItemClick = (e) => {
    setContrCat(e.itemData.type);
  };

  const displayExpr = (item) => {
    if (item) {
      return `${item.quotNo} ${item.AOS ? " (" + item.AOS + ")" : ``}`;
    } else {
      return null;
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Tabs
          dataSource={dataSource}
          defaultSelectedIndex={0}
          height={40}
          width={"auto"}
          style={
            {
              // float: "left",
            }
          }
          itemRender={itemRender}
          onItemClick={onItemClick}
        />
        {/* <div
          style={{
            marginLeft: "20px",
          }}
        >
          <QuotationListComponent
            dataSource={quotDataSource}
            quotListValue={quotListValue}
            setQuotListValue={setQuotListValue}
          /> */}
        {/* <TagBox
            dataSource={quotDataSource}
            displayExpr={displayExpr}
            valueExpr={"quotNo"}
            showSelectionControls={true}
            applyValueMode="useButtons"
            searchEnabled={true}
            showClearButton={true}
            grouped={true}
            width={"1000"}
            style={
              {
                // float: "left",
              }
            }
          /> */}
        {/* </div> */}
      </div>
      {contrCat == "ALL" &&
        quot.map(function (_quot) {
          return (
            <div>
              <div style={{ margin: "16px 0px" }}>
                <div>
                  <Toolbar>
                    <Item location={"before"}>
                      <span
                        style={{
                          fontWeight: 500,
                          color: "#009688",
                          marginLeft: "10px",
                        }}
                      >
                        {_quot.quotNo}
                        {_quot.AOS ? ": " + _quot.AOS : ``}
                      </span>
                    </Item>
                  </Toolbar>
                  <SalesGrid sales={sales} quot={_quot} />
                  <ScrollToTopButtonComponent />
                </div>
              </div>
            </div>
          );
        })}
      {contrCat == "PF" &&
        quot
          .filter(function (_quot) {
            if (_quot.contrCat == "1") {
              return true;
            }
          })
          .map(function (_quot) {
            return (
              <div>
                <div style={{ margin: "16px 0px" }}>
                  <div>
                    <Toolbar>
                      <Item location={"before"}>
                        <span
                          style={{
                            fontWeight: 500,
                            color: "#009688",
                            marginLeft: "10px",
                          }}
                        >
                          {_quot.quotNo}
                        </span>
                      </Item>
                    </Toolbar>
                    <SalesGrid sales={sales} quot={_quot} />
                    <ScrollToTopButtonComponent />
                  </div>
                </div>
              </div>
            );
          })}
      {contrCat == "AOS" &&
        quot
          .filter(function (_quot) {
            if (_quot.contrCat == "2") {
              return true;
            }
          })
          .map(function (_quot) {
            return (
              <div>
                <div style={{ margin: "16px 0px" }}>
                  <div>
                    <Toolbar>
                      <Item location={"before"}>
                        <span
                          style={{
                            fontWeight: 500,
                            color: "#009688",
                            marginLeft: "10px",
                          }}
                        >
                          {_quot.quotNo} {_quot.AOS ? ": " + _quot.AOS : ``}
                        </span>
                      </Item>
                    </Toolbar>
                    <SalesGrid sales={sales} quot={_quot} />
                    <ScrollToTopButtonComponent />
                  </div>
                </div>
              </div>
            );
          })}
    </>
  );
}
